import { supabase } from '@/lib/supabaseClient';

export const GALLERY_PHOTOS_BUCKET = 'gallery-photos';

export const GALLERY_CATEGORIES = [
  { value: 'fleet', label: 'Our Fleet' },
  { value: 'trips', label: 'Customer Trips' },
  { value: 'destinations', label: 'Destinations' },
];

export function galleryCategoryLabel(value) {
  return GALLERY_CATEGORIES.find((c) => c.value === value)?.label ?? value;
}

/** SEO-friendly alt text for gallery images. */
export function galleryPhotoAltText(photo) {
  const caption = photo?.caption?.trim();
  if (caption) return `Atithi Travel - ${caption}`;
  const category = photo?.category || 'gallery';
  return `Atithi Travel - ${category} photo`;
}

export function safeStorageFilename(original) {
  const base = (original || 'image.jpg').split(/[/\\]/).pop() || 'image.jpg';
  return base.replace(/[^a-zA-Z0-9._-]/g, '_').slice(0, 80) || 'image.jpg';
}

export function buildGalleryPhotoStoragePath(category, filename) {
  return `${category}/${Date.now()}-${safeStorageFilename(filename)}`;
}

export function storagePathFromGalleryPhotoUrl(url) {
  if (!url || typeof url !== 'string') return null;
  const markers = [
    `/storage/v1/object/public/${GALLERY_PHOTOS_BUCKET}/`,
    `/object/public/${GALLERY_PHOTOS_BUCKET}/`,
  ];
  for (const marker of markers) {
    const idx = url.indexOf(marker);
    if (idx !== -1) {
      return decodeURIComponent(url.slice(idx + marker.length).split('?')[0]);
    }
  }
  return null;
}

export function resolveGalleryPhotoUrl(imageUrl) {
  if (!imageUrl) return null;
  if (/^https?:\/\//i.test(imageUrl)) return imageUrl;
  const publicUrl = process.env.PUBLIC_URL || '';
  return `${publicUrl}${imageUrl.startsWith('/') ? imageUrl : `/${imageUrl}`}`;
}

export async function uploadGalleryPhoto(file, category) {
  const path = buildGalleryPhotoStoragePath(category, file.name);
  const { error: uploadError } = await supabase.storage
    .from(GALLERY_PHOTOS_BUCKET)
    .upload(path, file, {
      contentType: file.type,
      upsert: false,
    });
  if (uploadError) throw uploadError;

  const { data: urlData } = supabase.storage.from(GALLERY_PHOTOS_BUCKET).getPublicUrl(path);
  return urlData.publicUrl;
}

export async function deleteGalleryPhotoFromUrl(imageUrl) {
  const storagePath = storagePathFromGalleryPhotoUrl(imageUrl);
  if (!storagePath) return;
  const { error } = await supabase.storage.from(GALLERY_PHOTOS_BUCKET).remove([storagePath]);
  if (error) throw error;
}
